import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad2Actividad6.mp3";

const Actividad8 = () => {
  const infoUnidad = modulo14.content[1];
  const infoAct = modulo14.content[1].activities[7];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[1].name}: ${modulo14.content[1].activities[8].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[8].path}`,
    titlePrev: `${modulo14.content[1].name}: ${modulo14.content[1].activities[6].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[6].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul>
            <li>Lee los siguientes dos casos y responde las preguntas.</li>
            <li>
              Hazle estas preguntas a tu compañero, compañera o familiar.
              Comparen sus respuestas. ¿Estuvieron de acuerdo o no?
            </li>
          </ul>
          <div className="row align-items-center mt-5 mb-2 px-4">
            <div className="col-lg-10 col-12">
              <div className="border-2 shadow-sm border rounded pt-3 px-4 mb-4">
                <strong>Caso 1:</strong>
                <br />
                <p className="fs-5">
                  Cada vez se hace más popular la palabra “chatear” en el Perú.
                  Esta palabra viene del inglés “chat” y significa mantener una
                  conversación con otra persona a través de internet.
                </p>
              </div>
            </div>
            <div className="col-12">
              <p className="text-sm">
                Algunas personas están en desacuerdo con usar la palabra
                “chatear”. ¿Por qué crees que pasa eso?
              </p>
              <textarea rows={"4"} className="form-control w-100 mb-4" />

              <p className="text-sm">
                ¿Qué otra palabra se podría usar que signifique lo mismo?
              </p>
              <textarea rows={"4"} className="form-control w-100 mb-3" />

              <p className="text-sm">
                ¿Tú estás de acuerdo con usar la palabra “chatear”? ¿Por qué?
              </p>
              <textarea rows={"6"} className="form-control w-100 mb-3" />
            </div>
          </div>

          <div className="row align-items-center mt-5 mb-0 px-4">
            <div className="col-lg-10 col-12">
              <div className="border-2 shadow-sm border rounded pt-3 px-4 mb-4">
                <strong>Caso 2:</strong>
                <br />
                <p className="fs-5">
                  En awajún, “bote” se dice “búti” y “botella” se dice “butíya”.
                  Como puedes ver, se trata de palabras que se han tomado
                  prestadas del castellano.
                </p>
              </div>
            </div>
            <div className="col-12">
              <p className="text-sm">
                ¿Por qué crees que los hablantes de awajún se han prestado esas
                palabras del castellano?
              </p>
              <textarea rows={"4"} className="form-control w-100 mb-4" />

              <p className="text-sm">
                ¿Te parece bien prestarse palabras del castellano para el
                awajún? ¿Por qué?{" "}
              </p>
              <textarea rows={"4"} className="form-control w-100 mb-3" />
            </div>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea las indicaciones: Lee los siguientes dos casos y responde las
            preguntas. Hazle estas preguntas a tu compañero, compañera o
            familiar. Comparen sus respuestas. ¿Estuvieron de acuerdo o no? Pida
            al niño o a la niña que lean los casos. Luego pida que lea las
            preguntas para cada caso. Dé un tiempo para responder, retome sus
            respuestas y coméntelas:
          </li>
          <li>
            Caso 1: - Algunas personas están en desacuerdo con usar la palabra
            “chatear”. ¿Por qué crees que pasa eso? (Posible respuesta: Algunas
            personas consideran que, por ser una palabra en inglés, no debería
            usarse en el castellano). - ¿Qué otra palabra se podría usar que
            signifique lo mismo? (Posible respuesta: Podríamos decir charlar o
            conversar). - ¿Tú estás de acuerdo con usar la palabra “chatear”?
            ¿Por qué? (Posible respuesta: La respuesta es libre pero es
            interesante destacar que al usar la palabra “chatear” estamos dando
            información sobre el medio en que se realiza la acción (Internet).
            Es una muestra de que el lenguaje va evolucionando en la medida que
            las personas lo usan).
          </li>
          <li>
            Caso 2: - ¿Por qué crees que los hablantes de awajún se han prestado
            esas palabras del castellano? (Posible respuesta: Algunos objetos no
            se usan cotidianamente en comunidades que usan una determinada
            lengua. Por eso, estas comunidades tienden a apropiarse de los
            nuevos objetos con los nombres con que ellos llegan; en este caso,
            puede ser que tanto el bote como la botella llegaran a la comunidad
            awajún con sus nombres en castellano). - ¿Te parece bien prestarse
            palabras del castellano para el awajún? ¿Por qué? (Posible
            respuesta: La respuesta es libre pero se puede destacar que los
            préstamos de palabras entre lenguas son inevitables cuando hay
            contacto entre las lenguas).
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
